const PREFIX = '/cguardian/api'

// URL
const URLS = {
  OSS_LOGIN: PREFIX + '/users/sso-login', // 登录
  LOGOUT: PREFIX + '/users/logout', // 登出
  GET_CONSTANTS: PREFIX + '/resource/get-business-type-and-subject',
  GET_MY_TASK_LIST: PREFIX + '/workflow/task/get-my-task', // 我的任务
  GET_SUB_TASK: PREFIX + '/workflow/task/get-my-sub-task', // 子任务列表
  GET_SUB_TASK_INSTANCE: PREFIX + '/workflow/instance/get-instance', // 子任务信息
  FINISH_TASK: PREFIX + '/workflow/instance/finish-task', // 修改任务状态
  SEND_MESSAGE: PREFIX + '/messages/send-message', // 发送消息
  SAVE_EXTRA_DATA: PREFIX + '/sensitive/data/add', // 保存图片样本和敏感词
  UPLOAD_URL: PREFIX + '/sensitive/pic/upload',
  CONTENT_UPLOAD: PREFIX + '/resource/add', // 内容上传
  CONTENT_BATCH_CONFIRM_MODIFY: PREFIX + '/workflow/instance/batch-finish-task', // 批量内容修改确认
  RECORD_FINISH_TIME: PREFIX + '/workflow/instance/record-finish-time', // 记录任务处理时间流
  GET_FULL_TEXT: PREFIX + '/workflow/instance/get-instance-full-text' // 获取完整拼接文案
}

// cookie保存用户名/groups信息/过期时间
const USER_ID = 'id'
const USER_NAME = 'username'
const USER_GROUPS = 'perm_groups'
const USER_PLATFORM = 'user_platform'
const LONG_DAYS = 70 * 365

// 全局常量
const SENSITIVE_WORDS = 'sensitive_type_data'
const SUBJECTS = 'object_data'
const BUSSINESS = 'business_type_data' //business_type_data是资源来源
const BUSSINESS_SUBJECTS = 'business_subject_data'
const BUSSINESS_SIDES = 'business_sides_data'
const BUSSINNESS_CATEGORY = 'business_category_data'
const BUSINESS_APPROVE_REASON = 'business_approve_reason'
const BUSINESS_WITH_NULL = 'business_type_data_pro'
const SENSITIVE_WORD_TYPE = 'sensitive_word_type_data'
const SENSITIVE_PIC_TYPE = 'sensitive_word_pic_data'
const SENSITIVE_CONTENT_TYPE = 'sensitive_word_content_data'
const BUSINESS_SOURCE_DATA = 'business_source_data'

export {
  URLS,
  USER_NAME,
  USER_ID,
  USER_GROUPS,
  USER_PLATFORM,
  LONG_DAYS,
  SENSITIVE_WORDS,
  SUBJECTS,
  BUSSINESS,
  BUSSINESS_SUBJECTS,
  BUSSINESS_SIDES,
  BUSSINNESS_CATEGORY,
  BUSINESS_APPROVE_REASON,
  BUSINESS_WITH_NULL,
  SENSITIVE_WORD_TYPE,
  SENSITIVE_PIC_TYPE,
  SENSITIVE_CONTENT_TYPE,
  BUSINESS_SOURCE_DATA
}
